import React, { useEffect, useState } from 'react';
import Image from '../images/araku_valley.jpg'
// import { useNavigate } from 'react-router-dom'; 
import Navbar from './Navbar';
import Footer from './Footer';
import Features from './Features';
import FAQ from './FAQ';
import BoardOfDirectors from './BoardOfDirectors';


const Hero = () => {
  const [showHero, setShowHero] = useState(false);

  useEffect(() => {
    // Trigger animation after component mounts
    setShowHero(true);
  }, []);

  
  return (
    <>
    <Navbar />
    <section id="home" style={{
      // minHeight: '100vh',
      background: '#e8f0ee',
      display: 'flex',
      flexDirection: 'column',
      // justifyContent: 'center',
      padding: '20px 20px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        // position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url("https://images.pexels.com/photos/82256/pexels-photo-82256.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.12,
        filter: 'sepia(30%)',
      }}></div>

      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        width: '100%',
        position: 'relative',
        zIndex: 2,
      }}>
        <div style={{
          maxWidth: '650px',
          opacity: showHero ? 1 : 0,
          transform: showHero ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.8s ease, transform 0.8s ease',
        }}>
          <h1 style={{
            fontFamily: '"Playfair Display", serif',
            fontSize: 'clamp(2.5rem, 5vw, 4rem)',
            lineHeight: 1.2,
            color: '#5D4037',
            marginBottom: '1.5rem',
            fontWeight: 700,
          }}>About <br /> Bharat Araku Coffee</h1>
          
          <p style={{
            fontFamily: '"Source Sans Pro", sans-serif',
            fontSize: 'clamp(1.1rem, 2vw, 1.25rem)',
            lineHeight: 1.6,
            color: '#6B4226',
            marginBottom: '2rem',
            maxWidth: '560px',
          }}>
           As the brand itself says, Bharat, we proudly promote the Make in India initiative. Our qoffee is a celebration of India's heritage, crafted with love and care in the lush Araku Valley. 
          </p>
          
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '15px',
          }}>
            {/* <button onClick={CallValue}
             style={{
              backgroundColor: '#8B4513',
              color: '#FFF8E1',
              fontFamily: '"Source Sans Pro", sans-serif',
              fontSize: '1rem',
              fontWeight: 600,
              padding: '12px 28px',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 10px rgba(139, 69, 19, 0.2)',
              ':hover': {
                backgroundColor: '#A0522D',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 12px rgba(139, 69, 19, 0.3)',
              },
            }}>
              Join Now
            </button> */}
            
            <button
             style={{
              backgroundColor: 'transparent',
              color: '#8B4513',
              fontFamily: '"Source Sans Pro", sans-serif',
              fontSize: '1rem',
              fontWeight: 600,
              padding: '12px 28px',
              borderRadius: '6px',
              border: '2px solid #8B4513',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              ':hover': {
                backgroundColor: 'rgba(139, 69, 19, 0.1)',
              },
            }}> <a href="./CoffeeWorld" style={{textDecoration:"none", color: '#8B4513',}}>
              Learn More</a>
            </button>
          </div>
        </div>
        
        <div style={{
          position: 'absolute',
          right: '100px',
          bottom: '20px',
          width: '280px',
          height: '280px',
          backgroundSize: 'cover',
          borderRadius: '50%',
          border: '8px solid rgba(255, 248, 225, 0.7)',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
          opacity: showHero ? 1 : 0,
          transform: showHero ? 'translateX(0) rotate(0deg)' : 'translateX(50px) rotate(-10deg)',
          transition: 'opacity 1s ease 0.3s, transform 1s ease 0.3s',
          display: 'none',
          '@media (min-width: 992px)': {
            display: 'block',
          },
        }} className="lg:block">
         <img src={Image} alt="" style={{width:"400px",height:"400px",marginLeft:'-21.5%',marginTop:'-35%'}}/>
            
        </div> 
      </div>
      
    </section>   
    <Features id="features" />
    <BoardOfDirectors/>
    <FAQ />
    <Footer />
    </>
  );
};

export default Hero;